import { Box } from "@mui/material"
import GenersGridViewList from "./GenersGridViewList";
import GenerMenuOptions from "./GenerMenuOptions";
import { useEffect, useState } from "react";
import { sortDataBasedOnType } from "../../utility/jsonUtils";
import AddCategoryModal from "../../modals/AddCategoryModal";
import ConfirmDialog from "./ConfirmationDialog";
import NoData from "../NoData";
import { delay, isEqual, sortBy } from "lodash";
import { compareDataForUpdateOnServer, getChangedItemsInArray, getUpdatedObject } from "../../utility/GenersGridUtils";

export default function GenersGridView({ updatedGenersData, setUpdatedGenersData, openModal, setOpenModal, updateModal, setUpdateModal, sendUpdateDataFromGridView, currentGridItemForBreadCrumb, getGridViewTempUpdateForBreadCrumb, setBreadcrumbClicked, breadcrumbClicked, breadcrumb, setBreadcrumb, props }) {

  /**
   * Menu
   */
  const [menuAnchorEl, setMenuAnchorEl] = useState(null); // Menu anchor (for open/close)
  const [menuPosition, setMenuPosition] = useState(null); // Menu Position
  const [hoveredIndex, setHoveredIndex] = useState(null); // Track hover
  const [hoveredItem, setHoveredItem] = useState(null);

  const [modifiedGenersData, setModifiedGenersData] = useState(updatedGenersData);
  const [selectedEmptyItem, setSelectedEmptyItem] = useState(null);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);

  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedEditItem, setSelectedEditItem] = useState(false);
  const [isNoData, setIsNoData] = useState(false);

  useEffect(() => {
    if ((!modifiedGenersData || modifiedGenersData?.length === 0) && !breadcrumbClicked) {
      console.log("breadcrumb 4", breadcrumbClicked)
      setModifiedGenersData(sortDataBasedOnType(updatedGenersData));
      setBreadcrumb([{ title: "Geners", data: modifiedGenersData }])
      setIsNoData(true);
    }
    else {
      console.log("breadcrumb ==> ",breadcrumb)
      if (breadcrumbClicked) {
        console.log("breadcrumb 6",breadcrumb?.[breadcrumb?.length - 1]);
        setModifiedGenersData(sortDataBasedOnType(breadcrumb?.[breadcrumb?.length - 1]?.data))
        setBreadcrumbClicked(false);
        getGridViewTempUpdateForBreadCrumb(updatedGenersData);
        console.log("breadcrumb 7", breadcrumbClicked)
      }
      else {
        console.log("breadcrumb 8", breadcrumbClicked)
        console.log("updatedGenersData 8 : ", updatedGenersData)
        const length = breadcrumb?.length;
        if(length===1)
        {
          //setUpdatedGenersData(modifiedGenersData);
          setBreadcrumb(prev => {
            const updatedBreadcrumb = [...prev];
            if (updatedBreadcrumb[0]?.title === 'Geners') {
              updatedBreadcrumb[0] = {
                ...updatedBreadcrumb[0],
                data: [...modifiedGenersData],
              };
            }
            return updatedBreadcrumb;
          });
        }
        else{
          setBreadcrumb(prev => {
            const updatedBreadcrumb = [...prev];
            if (updatedBreadcrumb.length > 0) {
              const lastIndex = updatedBreadcrumb.length - 1;
              updatedBreadcrumb[lastIndex] = {
                ...updatedBreadcrumb[lastIndex],
                data: [...modifiedGenersData],
              };
            }
            return updatedBreadcrumb;
          });
        }
        getGridViewTempUpdateForBreadCrumb(updatedGenersData);
        setIsNoData(false);
      }
    }
  }, [updatedGenersData, modifiedGenersData, breadcrumbClicked])
 

  
  // useEffect(()=>{
  //   console.log(hoveredIndex)
  // },[hoveredIndex,hoveredItem])

  // useEffect(() => {
  //   //setUpdatedGenersData(modifiedGenersData)
  // }, [modifiedGenersData,updatedGenersData])

  const handleItemClick = (_item, _index) => {
    //console.log("item : ", _item)
    //console.log("index : ", _index)

    setSelectedEmptyItem(_item);

    currentGridItemForBreadCrumb(modifiedGenersData, _item, _index)

    if (_item?.children) {
      /**
       * Game here
       */
      setModifiedGenersData(sortDataBasedOnType(_item?.children));
    }

    else {
      if (_item?.type === 'trivia_category' || _item?.type === 'gener') {
        setIsNoData(true);
      } else if (_item?.type === 'trivia_sub_category' || _item?.type === 'show') {

      }
      else {

      }
    }
  }


  function handleMenuOpen(event, item, index) {
    // console.log("event : ", event)
    // console.log("item : ", item)
    // console.log("index : ", index)
    // console.log("hoveredIndex : ",hoveredIndex)

    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    //setHoveredIndex(index)
    setMenuPosition({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
    });
  }

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    //setSelectedCategory(null);
  }

  const handleMenuAction = (action, hoveredIndex, hoveredItem) => {
    //console.log(`Action "${action}" clicked for:`, hoveredItem);
    setSelectedAction(action);
    setConfirmOpen(true);
    handleMenuClose();
  }

  const handleConfirmAction = () => {
    setConfirmOpen(false);
    console.log("handleConfirmAction : ", selectedAction)
    console.log("hoveredIndex : ", hoveredIndex)
    console.log("hoveredItem : ", hoveredItem)
    if (selectedAction === 'edit') {
      setIsEditMode(true);
      setSelectedEditItem(hoveredItem)
      setOpenModal(true);
    }
    else if (selectedAction === 'remove') {
      const updatedGenersData = modifiedGenersData?.filter(r => r.id !== hoveredItem?.id);
      setModifiedGenersData(sortDataBasedOnType(updatedGenersData));
    }
    else if (selectedAction === 'activate' || selectedAction === 'deactivate') {
      const updatedGenersData = modifiedGenersData?.map((item, index) => {
        if (index === hoveredIndex) {
          //setSelectedItem(item);
          console.log("find")
          return { ...item, status: hoveredItem?.status === "active" ? "deactivated" : "active" }
        }
        return item
      })

      setModifiedGenersData(sortDataBasedOnType(updatedGenersData));
    }
    setHoveredIndex(null)
    setHoveredItem(null)
  }

  const handleAddSubmitBt = (newData) => {
    console.log("newData : ", newData);
    if (!isEditMode) {
      const updatedGenersData = [...modifiedGenersData, newData]; // Add new item to end
      setModifiedGenersData(sortDataBasedOnType(updatedGenersData));
    }
    else {
      const updatedGenersData = modifiedGenersData?.map(item => item?.id === newData?.id ? newData : item);
      setModifiedGenersData(sortDataBasedOnType(updatedGenersData));
    }
    dismissAddDialog();
  }

  const UpdateOnServer = (_original, _modified) => {
    console.log("UpdateOnServer : ",_original);
    const comapreResult = compareDataForUpdateOnServer(_original, _modified);
    if (!comapreResult) {
      var i_original = _original;
      var i_modified = _modified;
      const changes = getUpdatedObject(i_original, i_modified);    // Only returns the changed structure
      const { added, removed, modified } = getChangedItemsInArray(i_original, i_modified);
      //console.log("changes : ",changes);
      //console.log("added : ",added);
      //console.log("removed : ",removed);
      //console.log("modified : ",modified);
      sendUpdateDataFromGridView(_modified)
    }
    setUpdateModal(false);
  }

  const dismissAddDialog = () => {
    if (isEditMode) {
      setIsEditMode(false);
      setSelectedEditItem(null);
    }
    setOpenModal(false)
  }

  return (
    <Box sx={{ flexGrow: 1, }}>

      {!isNoData ? (<GenersGridViewList
        modifiedGenersData={modifiedGenersData}
        handleItemClick={handleItemClick}
        hoveredIndex={hoveredIndex}
        setHoveredIndex={setHoveredIndex}
        hoveredItem={hoveredItem}
        setHoveredItem={setHoveredItem}
        handleMenuOpen={handleMenuOpen}
        handleMenuClose={handleMenuClose}
      />) : (<NoData />)}


      {/* Dropdown Menu */}
      <GenerMenuOptions
        hoveredItem={hoveredItem}
        hoveredIndex={hoveredIndex}
        menuAnchorEl={menuAnchorEl}
        menuPosition={menuPosition}
        handleMenuAction={handleMenuAction}
        handleMenuClose={handleMenuClose}
      />

      {/* Confirm Alert Dialog */}
      <ConfirmDialog
        open={confirmOpen || updateModal}
        title="Confirm Action"
        content={updateModal ? "Are you sure you want to update on server!!" : `Are you sure you want to ${selectedAction} ?`}
        onClose={() => updateModal ? setUpdateModal(false) : setConfirmOpen(false)}
        onConfirm={updateModal ? UpdateOnServer(updatedGenersData, modifiedGenersData) : handleConfirmAction}
      />

      {/* Add Category */}
      <AddCategoryModal
        open={openModal}
        isEditMode={isEditMode}
        handleClose={() => dismissAddDialog()}
        handleAddSubmitBt={handleAddSubmitBt}
        selectedEmptyItem={selectedEmptyItem}
        selectedEditItem={selectedEditItem}
        modifiedGenersData={modifiedGenersData}
      />

    </Box>
  );
}